import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggle } from '../Actions/Cart.action';
import { translate } from '../Services/translation';

const MiniCart = () => {
    const dispatch = useDispatch();
    const { quantity, orderTotal, checkoutUrl, showInfo } = useSelector((state) => state.cart);
    const onToggle = () => dispatch(toggle());

    return (
        <div className="cart cart--mini">
            <a className="cart__link--block" href={checkoutUrl}>
                <i className="cart__icon">{quantity > 0 && <span className="cart__quantity">{quantity}</span>}</i>
                <span className="cart__link-text">{translate('minicart.checkout')}</span>
            </a>
            <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
                <span className="cart__close-button" onClick={() => onToggle()}></span>
                <p className="cart__info-row">
                    {quantity} {translate('minicart.numberofproduct')}
                </p>
                <p className="cart__info-row">
                    <b>{translate('minicart.total')}</b> {orderTotal}
                </p>
                <a href={checkoutUrl} className="cart__checkout-button">
                    {translate('minicart.checkout')}
                </a>
            </div>
        </div>
    );
};

export default MiniCart;
